import { render, staticRenderFns } from "./SelectColourWidget.vue?vue&type=template&id=a32b4672&"
import script from "./SelectColourWidget.vue?vue&type=script&lang=js&"
export * from "./SelectColourWidget.vue?vue&type=script&lang=js&"
import style0 from "./SelectColourWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports